// Servicio de ahorros del cliente (Módulo 6)
import { apiClient } from './api';
import { API_BASE_URL } from '../config';

export const savingsService = {
  /** Resumen + historial para la pestaña de ahorro. */
  async summary() {
    return apiClient.get(`${API_BASE_URL}/api/me/savings`);
  },

  /**
   * Último canje del usuario.
   *
   * Lo usa el sondeo de la pantalla del QR para detectar que la tienda ya
   * escaneó, y la pantalla de felicitación para saber cuánto ahorró.
   */
  async last() {
    return apiClient.get(`${API_BASE_URL}/api/me/savings/last`);
  },

  /** Detalle de un movimiento. */
  async detail(id) {
    return apiClient.get(`${API_BASE_URL}/api/me/savings/${id}`);
  },
};

export default savingsService;
